import { render, staticRenderFns } from "./TagArry.vue?vue&type=template&id=fa336f44&"
import script from "./TagArry.vue?vue&type=script&lang=js&"
export * from "./TagArry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports